import firebase from 'firebase';

const getDownloadURL = async (path: string): Promise<string | undefined> => {
  try {
    const appReference = await firebase.storage().ref(path);
    return await appReference.getDownloadURL();
  } catch (e) {
    return undefined;
  }
};

export const getMobileApk = async (
  subject: 'driver' | 'passenger',
): Promise<string | undefined> => {
  if (subject === 'driver') {
    return getDownloadURL('/android/driver/app.apk');
  }

  if (subject === 'passenger') {
    return getDownloadURL('/android/passenger/app.apk');
  }

  return;
};
